import axios from 'axios'
import React, { useState } from 'react'
import { Form } from 'react-bootstrap'
import { toast } from 'react-toastify'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { fetchCsrfCookie } from '../../redux/action/csrf/csrf-cookie'
import { useDispatch } from 'react-redux'
import { useRef } from 'react'
import SimpleReactValidator from 'simple-react-validator'
import {IoCloseCircleOutline} from 'react-icons/io5'

const Forms = () => {
    const [, setForceUpdate] = useState(false)
    const [btnLoading, setBtnLoading] = useState(false)
    const [username, setUsername] = useState("")
    const [code, setCode] = useState("")
    const [password, setPassword] = useState("")
    const [confirmPassword, setConfirmPassword] = useState("")
    const [usernameCheck, setUsernameCheck] = useState(true)
    const [enterCode, setEnterCode] = useState(false)
    const [newPassword, setNewPassword] = useState(false)
    const [cofirmed, setCofirmed] = useState(false)
    const [confirmLogo, setConfirmLogo] = useState(false)
    const [typingTimeout, setTypingTimeout] = useState(0)
    const {t} = useTranslation();
    let dispatch = useDispatch()

    const validator = useRef(new SimpleReactValidator({
        messages: {
          required:"پر کردن این فیلد الزامی است"
        },
    }))

    const handleUsernameChange = (e) => { setUsername(e.target.value) }
    const handleCodeChange = (e) => { setCode(e.target.value) }

    const handlePasswordChange = event => {
        setPassword(event.target.value)
        if (typingTimeout) { 
            clearTimeout(typingTimeout) 
        }
        setTypingTimeout(setTimeout(function () {
            if(confirmPassword !== event.target.value ) {
                setConfirmLogo(true)
            } else {
                setConfirmLogo(false)
            }
        }, 1000))
    }

    const handleConfirmPasswordChange = event => {
        setConfirmPassword(event.target.value)
        if (typingTimeout) { 
            clearTimeout(typingTimeout) 
        }
        setTypingTimeout(setTimeout(function () {
            if(password !== event.target.value ) {
                setConfirmLogo(true)
            } else {
                setConfirmLogo(false)
            }
        }, 1000))
    }

    const handleCheckUsername = (e) => {
        e.preventDefault()
        toast.info(t("toast_check_info") , {position: 'bottom-right',className: 'foo-bar'})
        dispatch(fetchCsrfCookie())
        setBtnLoading(true)
        if (validator.current.allValid()) {
            axios.post("auth/forgot-password", {username}, {withCredentials: true})
            .then(response => {
                setBtnLoading(false)
                setUsernameCheck(false)
                setEnterCode(true)
            })
            .catch(error => {
                setBtnLoading(false)
                if(error.response.status === 422 ) {
                    toast.dismiss()
                    toast.error(t("toast_username_not_valid") , {position: 'bottom-right',className: 'foo-bar'})
                } else {
                    toast.dismiss()
                    toast.error(t("toast_something_went_wrong") , {position: 'bottom-right',className: 'foo-bar'})
                }
            })
        } else {
            setBtnLoading(false)
            setForceUpdate(1)
            validator.current.showMessages()
            toast.dismiss()
            toast.error(t("toast_please_fill_in_all_fields") , {position: 'bottom-right',className: 'foo-bar'})
        }
    }

    const handleCheckCode = (e) => {
        e.preventDefault()
        toast.info(t("toast_check_info") , {position: 'bottom-right',className: 'foo-bar'})
        setBtnLoading(true)
        let data = {username, code}
        dispatch(fetchCsrfCookie())
        axios.post("auth/confirm-code", data, {withCredentials: true})
        .then(response => {
            setBtnLoading(false)
            setUsernameCheck(false)
            setEnterCode(false)
            setNewPassword(true)
        })
        .catch(error => {
            setBtnLoading(false)
            if(error.response.status === 422 ) {
                toast.error(t("toast_code_not_valid") , {position: 'bottom-right',className: 'foo-bar'})
            } else {
                toast.error(t("toast_something_went_wrong") , {position: 'bottom-right',className: 'foo-bar'})
            }
        })
    }

    const handleSetNewPassword = (e) => {
        e.preventDefault()
        setBtnLoading(true)
        let newPass = {username:username, password:password, confirm_password:confirmPassword}
        dispatch(fetchCsrfCookie())
        axios.post("auth/reset-password", newPass, {withCredentials: true})
        .then(response => {
            setBtnLoading(false)
            setNewPassword(false)
            setCofirmed(true)
        })
        .catch(error => {
            setBtnLoading(false)
            toast.error(t("toast_something_went_wrong") , {position: 'bottom-right',className: 'foo-bar'})
        })
    }

    return (
        <>
            {usernameCheck === true &&
                <div className="col-lg-6 p-0">
                    <div className="login-form">
                        <div className="segment">
                            <h1>{t("restore_password")}</h1>
                            <p> {t("restore_password_page_subtitle")} </p>
                        </div>
                        <Form>
                            <label>
                                <input type="text" name="username" placeholder={t("username")} value={username} onChange={e => handleUsernameChange(e)} />
                                <span className='validator_error'>{validator.current.message('username', username, 'required')}</span>
                             </label>
                            <button disabled={btnLoading ? true : false} className={btnLoading ? 'green btn-disabled' : 'green'} type="button" onClick={handleCheckUsername}>{t("send")}</button>
                        </Form>
                    </div>
                </div>
            }
            {enterCode === true &&
                <div className="col-lg-6 p-0">
                    <div className="login-form">
                        <div className="segment">
                            <h1>{t("Verification code")}</h1>
                            <p>{t("Please enter the verification code sent for your mobile number")}</p>
                        </div>
                        <Form>
                            <label>
                                <input type="text" name="code" placeholder={t("Verification code")} value={code} onChange={e => handleCodeChange(e)} />
                            </label>
                            <button disabled={btnLoading ? true : false} className={btnLoading ? 'green btn-disabled' : 'green'} type="button" onClick={handleCheckCode}>{t("send")}</button>
                        </Form>
                    </div>
                </div>
            }
            {newPassword === true &&
                <div className="col-lg-6 p-0">
                    <div className="login-form">
                        <div className="segment">
                            <h1>{t("password")}</h1>
                            <p>{t("please enter a new password")}</p>
                        </div>
                        <Form>
                            <label>
                                <input type="password" name="password" placeholder={t("new_password")} value={password} onChange={e => handlePasswordChange(e)} />
                            </label>
                            <div className='forgetPass-item'>
                                <label>
                                    <input type="password" name="confirm_password" placeholder={t("repeat_new_password")} value={confirmPassword} onChange={e => handleConfirmPasswordChange(e)} />
                                    {confirmLogo ? <IoCloseCircleOutline title='تکرار رمز عبور مطابقت ندارد' className='pass_validator' /> : "" }
                                </label>
                            </div>
                            <button className={btnLoading ? 'green btn-disabled' : 'green'} type="button" onClick={handleSetNewPassword} disabled={btnLoading ? true : false}>{t("send")}</button>
                        </Form>
                    </div>
                </div>
            }
            {cofirmed === true &&
                <div className="col-lg-6 p-0">
                    <div className="login-form">
                        <div className="segment">
                            <h1>{t("password changed")}</h1>
                            <p>{t("password changed successfully, log in via the link below")}</p>
                        </div>
                        <Link to="/login" className="btn btn-success btn-lg"> {t("login")} </Link>
                    </div>
                </div>
            }
        </>
    )
}

export default Forms
